import { render, staticRenderFns } from "./CarDataDetail.vue?vue&type=template&id=bc63de46&"
import script from "./CarDataDetail.vue?vue&type=script&lang=js&"
export * from "./CarDataDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports